import React from 'react';
import RouteHeader from '../RouteHeader/routeHeader';
import Card from '../../../Helper/CardWrapper/cardWrapper'
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import {connect} from 'react-redux';
import ActivityTable from './activityTable';
import { withStyles } from '@material-ui/core/styles';

const styles={
    headLine:{
        fontSize: 30,
        fontWeight:500
    }
};

class Activity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true
        }
    }

    render() {
        const {user,classes} = this.props;
        return (
            <div className='container-div'>
                <ContentGrid
                    header={
                        user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['Activity'] ?
                            <RouteHeader title={'Activity'}
                                         text={`See latest activity with ${user.results.AppUser.FirstName}.`}
                            /> : <span/>
                    }
                    content={
                        <Card
                            header={'Activity'}
                            CardHeaderProps={{
                                classes: {
                                    title:classes.headLine
                                }
                            }}
                            content={
                                <ActivityTable/>
                            }
                            CardContentProps={{
                                style: {borderTop: '1px solid #ddd'}
                            }}
                        />
                    }
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.loginResponse
    }
};
export default connect(mapStateToProps, null)(withStyles(styles)(Activity));